import { TableColumnModel } from '../../../Forms/models/table-column.model';

export const styleTypeColumnConfig: TableColumnModel = {
    heading: 'Styles.manageDialog.column.styleType',
    field: 'type',
    sortable: true,
    sortType: 'text',
    showInfoCircle: true,
    maxWidth: 350,
    cellStyleClass: 'agpr-table-cell--styleType'
};
